import { generateCustomIdentifier } from "./generateCustomIdentifier";

export default generateCustomIdentifier;
